import { useEffect, useState } from 'react';
import WeekView from './WeekView';
import MonthView from './MonthView';
import YearView from './YearView';
import DayView from './DayView';
import CalendarHeader from './CalendarHeader';
import useCalendar from '../../hooks/useCalendar';
import { calculateNewCalendarView } from '../../helper/date-helper';
import {
  CalendarViewEnum,
  MonthNames,
} from '../../constants/calendar.constant';

export type CalendarEvent = {
  id: string;
  title: string;
  start: Date;
  end: Date;
  description?: string;
  color?: string;
};

const Calendar = ({ events }: PropsType) => {
  const {
    today,
    currentDate,
    currentStartOfWeek,
    currentMonth,
    currentYear,
    setCurrentDate,
    setCurrentStartOfWeek,
    setCurrentMonth,
    setCurrentYear,
    resetCalendar,
  } = useCalendar();

  const [header, setHeader] = useState<string | null>(null);
  const [view, setView] = useState<CalendarViewEnum>(CalendarViewEnum.Month); // default to month view

  const clickToday = () => {
    resetCalendar();
  };

  const calendarViewClick = (action: 'Next' | 'Prev') => {
    const { updatedDate, updatedStartOfWeek, updatedMonth, updatedYear } =
      calculateNewCalendarView(
        action,
        view,
        currentMonth,
        currentYear,
        currentStartOfWeek
      );
    setCurrentDate(updatedDate);
    setCurrentStartOfWeek(updatedStartOfWeek);
    setCurrentMonth(updatedMonth);
    setCurrentYear(updatedYear);
  };

  useEffect(() => {
    switch (view) {
      case CalendarViewEnum.Day:
        break;
      case CalendarViewEnum.Month:
        setHeader(`${MonthNames[currentMonth]} ${currentYear}`);
        break;
      case CalendarViewEnum.Week:
        setHeader(
          `${
            MonthNames[currentStartOfWeek.getMonth()]
          } ${currentStartOfWeek.getFullYear()}`
        );
        break;
      case CalendarViewEnum.Year:
        break;
      default:
        break;
    }
  }, [currentStartOfWeek, currentMonth, currentYear, view]);

  const renderDayView = (): React.ReactNode => {
    return <DayView></DayView>;
  };

  const renderWeekView = (): React.ReactNode => {
    return (
      <WeekView
        currentDate={currentDate}
        onUpdateCurrentDate={(date: Date) => {
          setCurrentDate(date);
        }}
        events={events}
        startOfWeek={currentStartOfWeek}
        today={today}
      ></WeekView>
    );
  };
  const renderMonthView = (): React.ReactNode => {
    return (
      <MonthView
        today={today}
        currentMonth={currentMonth}
        currentYear={currentYear}
        events={events}
      ></MonthView>
    );
  };
  const renderYearView = (): React.ReactNode => {
    return <YearView></YearView>;
  };

  return (
    <>
      <CalendarHeader
        onClickNext={() => {
          calendarViewClick('Next');
        }}
        onClickPrev={() => {
          calendarViewClick('Prev');
        }}
        onClickToday={clickToday}
        header={header}
        onSelectView={(value) => {
          setView(value);
        }}
        view={view}
      />

      {view === CalendarViewEnum.Day && renderDayView()}
      {view === CalendarViewEnum.Week && renderWeekView()}
      {view === CalendarViewEnum.Month && renderMonthView()}
      {view === CalendarViewEnum.Year && renderYearView()}
    </>
  );
};

type PropsType = {
  events: CalendarEvent[];
};

export default Calendar;
